
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 42 42","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M27.26 11.174H14.74a3.628 3.628 0 00-3.623 3.624v12.518a3.628 3.628 0 003.623 3.624H27.26a3.628 3.628 0 003.624-3.624V14.798a3.628 3.628 0 00-3.624-3.624zM21 27.564a6.514 6.514 0 01-6.506-6.507A6.514 6.514 0 0121 14.55a6.514 6.514 0 016.507 6.507A6.515 6.515 0 0121 27.564zm6.716-11.668c-.849 0-1.54-.691-1.54-1.54 0-.849.691-1.54 1.54-1.54.85 0 1.54.691 1.54 1.54 0 .849-.69 1.54-1.54 1.54z","fill":"#F1F2F2"}}),_c('path',{attrs:{"d":"M21 17.3a3.762 3.762 0 00-3.757 3.756A3.763 3.763 0 0021 24.814a3.762 3.762 0 003.757-3.758A3.762 3.762 0 0021 17.299z","fill":"#F1F2F2"}}),_c('path',{attrs:{"d":"M21 0C9.402 0 0 9.402 0 21c0 11.597 9.402 21 21 21 11.597 0 21-9.403 21-21C42 9.402 32.597 0 21 0zm12.632 27.316a6.38 6.38 0 01-6.373 6.373H14.741a6.38 6.38 0 01-6.373-6.373V14.798a6.38 6.38 0 016.373-6.373h12.518a6.38 6.38 0 016.373 6.373v12.518z","fill":"#F1F2F2"}})])
          )
        }
      }
    